export default function buildMakeValveDeficiency({ validate, validators }) {
  return function makeValveDeficiency({
    id,
    valveId,
    deficiencyType,
    note,
    resolved = false,
    createdBy,
    createdDate = new Date(),
    modifiedBy,
    modifiedDate = new Date(),
    deletedBy,
    deletedDate,
  }) {
    const schema = {
      id: {
        prettyName: 'ID',
        validators: [validators.isString(), validators.exactLength(36)],
      },
      valveId: {
        prettyName: 'Valve ID',
        validators: [validators.isString(), validators.exactLength(36)],
      },
      deficiencyType: {
        prettyName: 'Note Type',
        validators: [validators.isString(), validators.notEmpty()],
      },
      note: {
        prettyName: 'Note',
        validators: [validators.isString()],
      },
      resolved: {
        prettyName: 'Resolved',
        validators: [validators.isBoolean(), validators.notNull()],
      },
    };

    return Object.freeze({
      get id() { return id },
      get valveId() { return valveId },
      get deficiencyType() { return deficiencyType },
      get note() { return note },
      get resolved() { return resolved },
      get createdBy() { return createdBy },
      get createdDate() { return createdDate ? new Date(createdDate) : null },
      get modifiedBy() { return modifiedBy },
      get modifiedDate() { return modifiedDate ? new Date(modifiedDate) : null },
      get deletedBy() { return deletedBy },
      get deletedDate() { return deletedDate ? new Date(deletedDate) : null },
      validate() {
        const errors = validate(this, schema);
        if (errors.length > 0) {
          const message = errors.map(e => e.name + ': ' + e.message).join('\n');
          const validationError = new Error(message);
          validationError.name = 'ValidationError';
          throw validationError;
        }
      }
    });
  }
}